import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AUbutton from '@gov.au/buttons';
import PropTypes from 'prop-types';

/* DEFAULT
 * The ExitModal component
 *
 * @param  {string}     title               - heading 
 * @param  {boolean}    isOpen              - show or hide modal
 * @param  {function}   toggleFunction      - function to show and hide
 */
export const ExitModal = ({ exitModalParams, children }) => {

    return (
        <Modal
            isOpen={exitModalParams.isOpen}
            toggle={exitModalParams.toggleFunction}
            modalTransition={{ timeout: 700 }}
            fade={false}>
            <ModalHeader>{exitModalParams.title ?? "Cancel application"}</ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
            <ModalFooter>
                {/* USED A TAG TO UTILISE HREF FOR EXTERNAL LINK AS OPPOSED TO HANDLING REDIRECT IN JS */}
                <AUbutton id="Yes" onClick={exitModalParams.OKFunction}>Yes</AUbutton>
                <AUbutton id="Cancel" as="secondary" onClick={exitModalParams.toggleFunction}>No</AUbutton>
            </ModalFooter>
        </Modal>
    )
}

ExitModal.defaultProps = {
    children: "If you leave this application it will be cancelled. Are you sure you want to cancel?"
};

ExitModal.propTypes = {
    exitModalParams: PropTypes.shape({
        title: PropTypes.string,
        isOpen: PropTypes.bool,
        toggleFunction: PropTypes.func,
        OKFunction: PropTypes.func
    }),
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
}